require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-fellows-switches-from-objective-c-to-swift-for-all-ios-courses.json") })
        }
      }, "path---blog-code-fellows-switches-from-objective-c-to-swift-for-all-ios-courses");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-fellows-switches-from-objective-c-to-swift-for-all-ios-courses!./.cache/json/blog-code-fellows-switches-from-objective-c-to-swift-for-all-ios-courses.json
// module id = 765
// module chunks = 231608221292675